import { createSlice } from "@reduxjs/toolkit";
import { g } from "framer-motion/client";
import { get } from "lodash";

export const atsDashboardSlice = createSlice({
  name: "atsdashboardslice",
  initialState: {
    totalAccountsList: [],
    totalAccountsCount: 0,
    backoutList: [],
    backoutTotal: 0,
    submissionsList: [],
    submissionsTotal: 0,
    placementsList: [],
    placementsTotal: 0,
    placementsLoading: false,
    loading: false,
    error: null,
    metrics: null,
    compareMetrics: null,
    roleBasedMetrics: null,
    metricsOverview: null,
    metricsGroup: null,
    reportToHierarchy: null,
    teamMetrics: null,
    compareTeamMetrics: null,
    teamRoleBasedMetrics: null,
    teamMetricsOverview: null,
    teamMetricsGroup: null,
    adminMetricsOverview: {
      raMetrics: null,
      bdmMetrics: null,
      recruiterMetrics: null
    },
    adminMetricsGroup: {
      raMetrics: null,
      bdmMetrics: null,
      recruiterMetrics: null
    },
    adminRAUsers: null,
    adminBDMUsers: null,
    adminRecruiterUsers: null,
    adminMetrics: null,
    adminMetricsLoading: null,
    adminCompareMetrics: null,
    treeHierarchy: [],
    treeHierarchyNodeWiseData: [],
    treeHierarchyNodeTab2Data: [],
    treeHierarchyNodeTab3Data: [],
    treeHierarchyNodeTab3TotalCount: null,
    treeHierarchynodeBDM: [],
    bdmTableData: [],
    bdmTableTotal: 0,
    bdmTableLoading: false,
    recruitTreeHierarchy: [],
    recruitTreeHierarchyNodeWiseData: [],
    recruitTreeHierarchyNodeTab2Data: [],
    recruitTreeHierarchyNodeTab3Data: [],
    recruitTreeHierarchyNodeTab3TotalCount: null,
    recruitTreeHierarchynodeBDM: []
  },
  reducers: {
    // Loading
    setStateLoading(state) {
      state.loading = true;
    },
    revertStateLoading(state) {
      state.loading = false;
    },

    //common
    getMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metrics = action.payload ?? {};
    },
    getMetricsFailure(state, action) {
      state.loading = false;
      state.adminMetricsLoading = false;
      state.error = "error";
    },
    getRoleBasedMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.roleBasedMetrics = action.payload ?? {};
    },
    getMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metricsOverview = action.payload ?? {};
    },
    getMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.metricsGroup = action.payload ?? {};
    },
    setreportToHierarchy(state, action) {
      state.reportToHierarchy = action.payload ?? {};
    },
    getTeamMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetrics = action.payload ?? {};
    },
    getTeamRoleBasedMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamRoleBasedMetrics = action.payload ?? {};
    },
    getTeamMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetricsOverview = action.payload ?? {};
    },
    getTeamMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.teamMetricsGroup = action.payload ?? {};
    },
    getCompareMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.compareMetrics = action.payload ?? {};
    },
    getCompareTeamMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.compareTeamMetrics = action.payload ?? {};
    },

    //RA
    getRAMetricsStart(state) {
      state.loading = true;
    },
    getRARoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getRAMetricsOverviewStart(state) {
      state.loading = true;
    },
    getRAMetricsGroupStart(state) {
      state.loading = true;
    },
    getRACompareMetricsStart(state, action) {
      state.loading = true;
    },

    //BDM
    getBDMMetricsStart(state) {
      state.loading = true;
    },
    getBDMRoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getBDMMetricsOverviewStart(state) {
      state.loading = true;
    },
    getBDMMetricsGroupStart(state) {
      state.loading = true;
    },
    getBDMCompareMetricsStart(state, action) {
      state.loading = true;
    },

    //RECRUITWER
    getRecruiterMetricsStart(state) {
      state.loading = true;
    },
    getRecruiterRoleBasedMetricsStart(state) {
      state.loading = true;
    },
    getRecruiterMetricsOverviewStart(state) {
      state.loading = true;
    },
    getRecruiterMetricsGroupStart(state) {
      state.loading = true;
    },
    getRecruiterCompareMetricsStart(state, action) {
      state.loading = true;
    },

    //ADMIN
    getAdminRAMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminBDMMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminRecruiterMetricsOverviewStart(state) {
      state.loading = true;
    },
    getAdminRAMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.raMetrics = action.payload ?? {};
    },
    getAdminBDMMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.bdmMetrics = action.payload ?? {};
    },
    getAdminRecruiterMetricsOverviewSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsOverview.recruiterMetrics = action.payload ?? {};
    },
    getAdminRAMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminBDMMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminRecruiterMetricsGroupStart(state) {
      state.loading = true;
    },
    getAdminRAMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.raMetrics = action.payload ?? {};
    },
    getAdminBDMMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.bdmMetrics = action.payload ?? {};
    },
    getAdminRecruiterMetricsGroupSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminMetricsGroup.recruiterMetrics = action.payload ?? {};
    },
    getAdminUsersStart(state, action) {
      state.loading = true;
    },
    setAdminRAUsers(state, action) {
      state.adminRAUsers = action.payload ?? {};
    },
    setAdminBDMUsers(state, action) {
      state.adminBDMUsers = action.payload ?? {};
    },
    setAdminRecruiterUsers(state, action) {
      state.adminRecruiterUsers = action.payload ?? {};
    },
    getAdminMetricsStart(state) {
      state.loading = true;
      state.adminMetricsLoading = true;
    },
    getAdminMetricsSuccess(state, action) {
      state.loading = false;
      state.adminMetricsLoading = false;
      state.error = false;
      state.adminMetrics = action.payload ?? {};
    },
    getAdminCompareMetricsStart(state) {
      state.loading = true;
    },
    getAdminCompareMetricsSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.adminCompareMetrics = action.payload ?? {};
    },
    // Total Accounts List
    getAdminTotalAccountsListStart(state) {
      state.loading = true;
    },

    getAdminTotalAccountsListSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.totalAccountsList = action.payload?.list || [];
      state.totalAccountsCount = action.payload?.total || 0;
    },

    getAdminTotalAccountsListFailure(state) {
      state.loading = false;
      state.error = true;
    },
    // Backout List
    getBackoutListStart: (state) => {
      state.loading = true;
    },

    getBackoutListSuccess: (state, action) => {
      state.loading = false;
      state.backoutList = action.payload.list;
      state.backoutTotal = action.payload.total;
    },

    getBackoutListFailure: (state) => {
      state.loading = false;
    },

    //placement list
    getPlacementsListStart: (state) => {
      state.loading = true;
    },

    getPlacementsListSuccess: (state, action) => {
      state.loading = false;
      state.placementsList = action.payload.list;
      state.placementsTotal = action.payload.total;
    },

    getPlacementsListFailure: (state) => {
      state.loading = false;
    },
    getTreeHierarchyDataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchy = action.payload ?? [];
    },
    getTreeHierarchyDataFailure(state) {
      state.loading = false;
    },
    getTreeHierarchyNodeDataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchyNodeWiseData = action.payload ?? [];
    },
    getTreeHierarchyNodeDataFailure(state) {
      state.loading = false;
    },
    getTreeHierarchyNodeTab2DataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeTab2DataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchyNodeTab2Data = action.payload ?? [];
    },
    getTreeHierarchyNodeTab2DataFailure(state) {
      state.loading = false;
    },
    getTreeHierarchyNodeTab3DataStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeTab3DataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchyNodeTab3Data = action.payload ?? [];
    },
    getTreeHierarchyNodeTab3DataFailure(state) {
      state.loading = false;
    },
    getTreeHierarchyNodeTab3TotalCountStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeTab3TotalCountSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchyNodeTab3TotalCount = action.payload ?? null;
    },
    getTreeHierarchyNodeTab3TotalCountFailure(state) {
      state.loading = false;
      state.treeHierarchyNodeTab3TotalCount = null;
    },
    getTreeHierarchyNodeBDMStart(state) {
      state.loading = true;
    },
    getTreeHierarchyNodeBDMSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.treeHierarchynodeBDM = action.payload ?? null;
    },
    getTreeHierarchyNodeBDMFailure(state) {
      state.loading = false;
    },
    // BDM Table
    getBDMTableDataStart(state) {
      state.bdmTableLoading = true;
    },
    getBDMTableDataSuccess(state, action) {
      state.bdmTableLoading = false;
      state.error = false;
      state.bdmTableData = action.payload?.data ?? [];
      state.bdmTableTotal = action.payload?.totalCount ?? 0;
    },
    getBDMTableDataFailure(state) {
      state.bdmTableLoading = false;
    },

    //recruitTreeHirerchy
    getRecruitTreeHierarchyDataStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchy = action.payload ?? [];
    },
    getRecruitTreeHierarchyDataFailure(state) {
      state.loading = false;
    },

    getRecruitTreeHierarchyNodeDataStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyNodeDataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchyNodeWiseData = action.payload ?? [];
    },
    getRecruitTreeHierarchyNodeDataFailure(state) {
      state.loading = false;
    },

    getRecruitTreeHierarchyNodeTab2DataStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyNodeTab2DataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchyNodeTab2Data = action.payload ?? [];
    },
    getRecruitTreeHierarchyNodeTab2DataFailure(state) {
      state.loading = false;
    },

    getRecruitTreeHierarchyNodeTab3DataStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyNodeTab3DataSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchyNodeTab3Data = action.payload ?? [];
    },
    getRecruitTreeHierarchyNodeTab3DataFailure(state) {
      state.loading = false;
    },

    getRecruitTreeHierarchyNodeTab3TotalCountStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyNodeTab3TotalCountSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchyNodeTab3TotalCount = action.payload ?? null;
    },
    getRecruitTreeHierarchyNodeTab3TotalCountFailure(state) {
      state.loading = false;
      state.recruitTreeHierarchyNodeTab3TotalCount = null;
    },

    getRecruitTreeHierarchyNodeBDMStart(state) {
      state.loading = true;
    },
    getRecruitTreeHierarchyNodeBDMSuccess(state, action) {
      state.loading = false;
      state.error = false;
      state.recruitTreeHierarchynodeBDM = action.payload ?? [];
    },
    getRecruitTreeHierarchyNodeBDMFailure(state) {
      state.loading = false;
    },
  },
});

export const {
  // Loading
  setStateLoading,
  revertStateLoading,

  //common
  getMetricsSuccess,
  getMetricsFailure,
  getRoleBasedMetricsSuccess,
  getMetricsOverviewSuccess,
  getMetricsGroupSuccess,
  setreportToHierarchy,
  getTeamMetricsSuccess,
  getTeamRoleBasedMetricsSuccess,
  getTeamMetricsOverviewSuccess,
  getTeamMetricsGroupSuccess,
  getCompareMetricsSuccess,
  getCompareTeamMetricsSuccess,

  //RA DASHBOARD
  getRAMetricsStart,
  getRAMetricsOverviewStart,
  getRAMetricsGroupStart,
  getRARoleBasedMetricsStart,
  getCompareMetricsStart,
  getRACompareMetricsStart,

  //BDM
  getBDMMetricsStart,
  getBDMRoleBasedMetricsStart,
  getBDMMetricsOverviewStart,
  getBDMMetricsGroupStart,
  getBDMCompareMetricsStart,

  //RECRUITER
  getRecruiterMetricsStart,
  getRecruiterRoleBasedMetricsStart,
  getRecruiterMetricsOverviewStart,
  getRecruiterMetricsGroupStart,
  getRecruiterCompareMetricsStart,

  //ADMIN
  getAdminRAMetricsOverviewStart,
  getAdminBDMMetricsOverviewStart,
  getAdminRecruiterMetricsOverviewStart,
  getAdminRAMetricsOverviewSuccess,
  getAdminBDMMetricsOverviewSuccess,
  getAdminRecruiterMetricsOverviewSuccess,
  getAdminRAMetricsGroupStart,
  getAdminBDMMetricsGroupStart,
  getAdminRecruiterMetricsGroupStart,
  getAdminRAMetricsGroupSuccess,
  getAdminBDMMetricsGroupSuccess,
  getAdminRecruiterMetricsGroupSuccess,
  getAdminUsersStart,
  setAdminRAUsers,
  setAdminBDMUsers,
  setAdminRecruiterUsers,
  getAdminMetricsStart,
  getAdminMetricsSuccess,
  getAdminCompareMetricsStart,
  getAdminCompareMetricsSuccess,
  getAdminTotalAccountsListStart,
  getAdminTotalAccountsListSuccess,
  getAdminTotalAccountsListFailure,
  getBackoutListStart,
  getBackoutListSuccess,
  getBackoutListFailure,
  getPlacementsListStart,
  getPlacementsListSuccess,
  getPlacementsListFailure,
  getTreeHierarchyDataFailure,
  getTreeHierarchyDataSuccess,
  getTreeHierarchyDataStart,
  getTreeHierarchyNodeDataStart,
  getTreeHierarchyNodeDataSuccess,
  getTreeHierarchyNodeDataFailure,
  getTreeHierarchyNodeTab2DataStart,
  getTreeHierarchyNodeTab2DataSuccess,
  getTreeHierarchyNodeTab2DataFailure,
  getTreeHierarchyNodeTab3DataStart,
  getTreeHierarchyNodeTab3DataSuccess,
  getTreeHierarchyNodeTab3DataFailure,
  getTreeHierarchyNodeTab3TotalCountStart,
  getTreeHierarchyNodeTab3TotalCountSuccess,
  getTreeHierarchyNodeTab3TotalCountFailure,
  getTreeHierarchyNodeBDMStart,
  getTreeHierarchyNodeBDMSuccess,
  getTreeHierarchyNodeBDMFailure,
  getBDMTableDataStart,
  getBDMTableDataSuccess,
  getBDMTableDataFailure,

  //recruit tree hirer
  getRecruitTreeHierarchyDataStart,
  getRecruitTreeHierarchyDataSuccess,
  getRecruitTreeHierarchyDataFailure,

  getRecruitTreeHierarchyNodeDataStart,
  getRecruitTreeHierarchyNodeDataSuccess,
  getRecruitTreeHierarchyNodeDataFailure,

  getRecruitTreeHierarchyNodeTab2DataStart,
  getRecruitTreeHierarchyNodeTab2DataSuccess,
  getRecruitTreeHierarchyNodeTab2DataFailure,

  getRecruitTreeHierarchyNodeTab3DataStart,
  getRecruitTreeHierarchyNodeTab3DataSuccess,
  getRecruitTreeHierarchyNodeTab3DataFailure,

  getRecruitTreeHierarchyNodeTab3TotalCountStart,
  getRecruitTreeHierarchyNodeTab3TotalCountSuccess,
  getRecruitTreeHierarchyNodeTab3TotalCountFailure,

  getRecruitTreeHierarchyNodeBDMStart,
  getRecruitTreeHierarchyNodeBDMSuccess,
  getRecruitTreeHierarchyNodeBDMFailure,

} = atsDashboardSlice.actions;

export default atsDashboardSlice.reducer;
